import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { OutlineButton } from '../Button';
import theme, { textStyles as ts } from '../../theme';

const OuterContainer = styled.div`
  width: 100%;
  background-color: ${theme('colors.destructive')};
  ${({ fixed }) => (fixed
    ? `position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        z-index: 1`
    : '')};
`;

const InnerContainer = styled.div`
  position: relative;
  margin: 0px auto;
  display: flex;
  padding: ${theme('spacing.large')} 0;
  justify-content: space-between;
  max-width: ${theme('layout.pageWidth')};

  @media (max-width: ${theme('layout.pageWidth')}) {
    padding: ${theme('spacing.large')} ${theme('spacing.regular')};
  }
`;

const Message = styled.p`
  ${ts.body}
  color: ${theme('colors.backgroundLight')};
  max-width: 500px;
`;

const ButtonWrapper = styled.div`
  position: absolute;
  top: 0px;
  bottom: 0px;
  right: 0;
  display: flex;
  align-items: center;

  @media (max-width: ${theme('layout.pageWidth')}) {
    right: ${theme('spacing.regular')};
    position: relative;
    margin: 0 0 0 ${theme('spacing.regular')};
  }
`;

const Button = styled(OutlineButton)`
  height: ${theme('size.iconLarge')};
  color: white;
  line-height: ${theme('size.iconLarge').apply(h => `${parseFloat(h) - 2}px`)};
`;

const MessageBar = ({
  message,
  actionText,
  fixed,
  onAction,
  formAction,
  formNoValidate,
}) => (
  <OuterContainer fixed={fixed}>
    <InnerContainer>
      <Message>{message}</Message>
      <ButtonWrapper>
        <Button
          onClick={onAction}
          formNoValidate={formNoValidate}
          title={actionText}
          formAction={formAction}
          dynamicWidth
        />
      </ButtonWrapper>
    </InnerContainer>
  </OuterContainer>
);

MessageBar.propTypes = {
  message: PropTypes.string.isRequired,
  actionText: PropTypes.string.isRequired,
  fixed: PropTypes.bool,
  formAction: PropTypes.string.isRequired,
  onAction: PropTypes.func,
  formNoValidate: PropTypes.bool,
};

MessageBar.defaultProps = {
  formNoValidate: true,
  onAction: () => {},
  fixed: false,
};

export default MessageBar;
